export default "__VITE_ASSET__C_cPZ2Hw__"